import { t } from 'i18next';

const openSection = (selector, driverObj) => {
  const section = document.querySelector(selector);
  const collapse = section?.querySelector('.MuiPaper-root .MuiCollapse-root');
  if (collapse?.classList.contains('MuiCollapse-hidden')) {
    section.querySelector('h3')?.click();
    setTimeout(() => driverObj?.refresh(), 400);
    setTimeout(() => driverObj?.refresh(), 900);
  }
};

export const dashboardTourConfig = {
  onBeforeStart: () => {
    const section = document.querySelector('[data-tour="languages-section"]');
    if (!section) return false;
    const collapse = section.querySelector('.MuiPaper-root .MuiCollapse-root');
    if (collapse?.classList.contains('MuiCollapse-hidden')) {
      section.querySelector('h3')?.click();
      return true;
    }
    return false;
  },
  steps: ({ startTour } = {}) => [
    {
      element: '[data-tour="languages-section"]',
      popover: {
        title: t('onboarding.tour.step1.title'),
        description: t('onboarding.tour.step1.description'),
      },
    },
    {
      element: '[data-tour="language-selector"]',
      popover: {
        title: t('onboarding.tour.step2.title'),
        description: t('onboarding.tour.step2.description'),
      },
    },
    {
      element: '[data-tour="theme-selector"]',
      popover: {
        title: t('onboarding.tour.themeStep.title'),
        description: t('onboarding.tour.themeStep.description'),
      },
    },
    {
      element: '[data-tour="nav-translate"]',
      popover: {
        title: t('onboarding.tour.step3.title'),
        description: t('onboarding.tour.step3.description'),
      },
    },
    {
      element: '[data-tour="switcher-configurator"]',
      popover: {
        title: t('onboarding.tour.step4.title'),
        description: t('onboarding.tour.step4.description'),
        onPopoverRender: (popoverEl, { driver }) => {
          if (!startTour) return;
          const btn = document.createElement('button');
          btn.textContent = t('onboarding.tour.switcherTourBtn');
          btn.className = 'ly-tour-switcher-btn';
          btn.onclick = () => {
            driver.destroy();
            setTimeout(() => startTour(switcherConfiguratorTourConfig), 100);
          };
          popoverEl.footer.appendChild(btn);
        },
      },
    },
    {
      element: '[data-tour="theme-settings"]',
      popover: {
        title: t('onboarding.tour.step5.title'),
        description: t('onboarding.tour.step5.description'),
      },
    },
  ],
};


export const switcherConfiguratorTourConfig = {
  onBeforeStart: () => {
    const section = document.querySelector('[data-tour="switcher-configurator"]');
    if (!section) return false;
    const collapse = section.querySelector('.MuiPaper-root .MuiCollapse-root');
    if (collapse?.classList.contains('MuiCollapse-hidden')) {
      section.querySelector('h3')?.click();
      return true;
    }
    return false;
  },
  steps: () => [
    {
      element: '[data-tour="switcher-configurator"]',
      popover: {
        title: t('onboarding.switcherTour.step1.title'),
        description: t('onboarding.switcherTour.step1.description'),
      },
    },
    {
      element: '[data-tour="switcher-tabs"]',
      popover: {
        title: t('onboarding.switcherTour.step2.title'),
        description: t('onboarding.switcherTour.step2.description'),
      },
    },
    {
      element: '[data-tour="sidebar-settings"]',
      popover: {
        title: t('onboarding.switcherTour.step4.title'),
        description: t('onboarding.switcherTour.step4.description'),
      },
    },
    {
      element: '[data-tour="breakpoint-selector"]',
      popover: {
        title: t('onboarding.switcherTour.step5.title'),
        description: t('onboarding.switcherTour.step5.description'),
      },
    },
    {
      element: '[data-tour="switcher-preview"]',
      popover: {
        title: t('onboarding.switcherTour.step3.title'),
        description: t('onboarding.switcherTour.step3.description'),
      },
    },
  ],
};

// opens the first entry of the list; false when one is open already or there is none
const openFirstListEntry = () => {
  const allLists = document.querySelectorAll('#ItemsList');
  if (!allLists.length) return false;
  const targetList = allLists[allLists.length - 1];
  if (targetList.querySelector('.ItemsList_list-item.expanded')) return false;
  const firstItemLink = targetList.querySelector('.ItemsList_list-item a');
  if (!firstItemLink) return false;
  firstItemLink.click();
  return true;
};

export const itemsListTourConfig = {
  steps: () => {
    const allLists = document.querySelectorAll('#ItemsList');
    const targetList = allLists[allLists.length - 1] || null;
    const filterBar = targetList?.querySelector('[data-tour="items-filter-bar"]') || null;
    const filterBarHasInput = !!filterBar?.querySelector('input');

    const steps = [
      {
        element: '[data-tour="page-options-menu"]',
        popover: {
          title: t('onboarding.itemsListTour.step0.title'),
          description: t('onboarding.itemsListTour.step0.description'),
        },
      },
      {
        element: targetList || '#ItemsList',
        popover: {
          title: t('onboarding.itemsListTour.step1.title'),
          description: t('onboarding.itemsListTour.step1.description'),
        },
      },
      ...(filterBarHasInput ? [{
        element: filterBar,
        popover: {
          title: t('onboarding.itemsListTour.step2.title'),
          description: t('onboarding.itemsListTour.step2.description'),
        },
        onHighlightStarted: (driverObj) => {
          if (window.mainFrameRef) {
            window.mainFrameRef.scrollTop = 0;
            setTimeout(() => driverObj?.refresh(), 150);
          }
        },
      }] : []),
      {
        element: '[data-tour="items-options-btn"]',
        popover: {
          title: t('onboarding.itemsListTour.step3.title'),
          description: t('onboarding.itemsListTour.step3.description'),
        },
      },
      {
        element: '[data-tour="source-to-target-arrow"]',
        popover: {
          title: t('onboarding.itemsListTour.step4.title'),
          description: t('onboarding.itemsListTour.step4.description'),
        },
      },
      {
        element: '[data-tour="machine-translate-bar"]',
        popover: {
          title: t('onboarding.itemsListTour.step5.title'),
          description: t('onboarding.itemsListTour.step5.description'),
        },
      },
    ];

    // the first entry only opens once the tour reaches its fields: opening it up front changed the
    // url to that entry and scrolled the page away from the heading the first steps point at
    const beforeEntry = steps[steps.findIndex((step) => step.element === '[data-tour="items-options-btn"]') - 1];
    beforeEntry.popover.onNextClick = (element, step, { driver }) => {
      const opened = openFirstListEntry();
      setTimeout(() => driver.moveNext(), opened ? 600 : 0);
    };

    return steps;
  },
};

export const tourConfigsByRoute = {
  '/': dashboardTourConfig,
};

export const getTourConfigForRoute = (pathname) =>
  tourConfigsByRoute[pathname] ?? null;
